import { render } from "./Languages_als.vue?vue&type=template&id=94728b2e"
import script from "./Languages_als.vue?vue&type=script&lang=js"
export * from "./Languages_als.vue?vue&type=script&lang=js"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__